import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthGate } from './components/auth/auth-gate';
import { DashboardLayout } from './components/layout/dashboard-layout';
import { AdminLayout } from './components/layout/admin-layout';
import { LoginPage } from './pages/auth/login-page';
import { RegisterPage } from './pages/auth/register-page';
import { ForgotPasswordPage } from './pages/auth/forgot-password-page';
import { ResetPasswordPage } from './pages/auth/reset-password-page';
import { VerifyEmailPage } from './pages/auth/verify-email-page';
import { DashboardPage } from './pages/dashboard-page';
import { ProfilePage } from './pages/profile-page';
import { NumbersPage } from './pages/numbers-page';
import { SMSPage } from './pages/sms-page';
import { VoicePage } from './pages/voice-page';
import { WalletPage } from './pages/wallet-page';
import { SettingsPage } from './pages/settings-page';
import { NotificationsPage } from './pages/notifications-page';
import { SessionsPage } from './pages/sessions-page';
import { ApiKeysPage } from './pages/developer/api-keys-page';
import { WebhooksPage } from './pages/developer/webhooks-page';
import { AdminDashboardPage } from './pages/admin/admin-dashboard-page';
import { AdminUsersPage } from './pages/admin/admin-users-page';
import { AdminProvidersPage } from './pages/admin/admin-providers-page';
import { AdminNumbersPage } from './pages/admin/admin-numbers-page';
import { AdminSettlementsPage } from './pages/admin/admin-settlements-page';
import { AdminAnalyticsPage } from './pages/admin/admin-analytics-page';
import { AdminSettingsPage } from './pages/admin/admin-settings-page';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Auth routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/verify-email" element={<VerifyEmailPage />} />
        
        {/* Dashboard routes (protected) */}
        <Route element={<DashboardLayout />}>
          <Route element={<AuthGate />}>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/numbers" element={<NumbersPage />} />
            <Route path="/sms" element={<SMSPage />} />
            <Route path="/voice" element={<VoicePage />} />
            <Route path="/wallet" element={<WalletPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/notifications" element={<NotificationsPage />} />
            <Route path="/sessions" element={<SessionsPage />} />
            <Route path="/developer/api-keys" element={<ApiKeysPage />} />
            <Route path="/developer/webhooks" element={<WebhooksPage />} />
          </Route>
        </Route>
        
        {/* Admin routes (protected, admin only) */}
        <Route element={<AdminLayout />}>
          <Route element={<AuthGate requiredRole="admin" />}>
            <Route path="/admin" element={<AdminDashboardPage />} />
            <Route path="/admin/users" element={<AdminUsersPage />} />
            <Route path="/admin/providers" element={<AdminProvidersPage />} />
            <Route path="/admin/numbers" element={<AdminNumbersPage />} />
            <Route path="/admin/settlements" element={<AdminSettlementsPage />} />
            <Route path="/admin/analytics" element={<AdminAnalyticsPage />} />
            <Route path="/admin/settings" element={<AdminSettingsPage />} />
          </Route>
        </Route>
        
        {/* Redirect root to dashboard or login */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;